export var LOAN_NICKNAME_URL = "v1/loan/nickname/update";
//# sourceMappingURL=endpoints.js.map